import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import { getTranslation, mergeTranslations, TranslatedValue, Translations } from './common/TranslatedValue';

const CREATE_AD = gql`
  mutation CreateAd($input: CreateAdInput!) {
    createAd(input: $input) {
      id
      title
    }
  }
`;

export function CreateAdDialog() {
  const navigate = useNavigate();
  const [title, setTitleState] = useState<Translations>({});
  const titleRef = useRef(title);
  const setTitle = (next: Translations) => {
    titleRef.current = next;
    setTitleState(next);
  };
  const [createAd] = useMutation(CREATE_AD);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const currentTitle = titleRef.current;
    if (!getTranslation(currentTitle).trim()) {
      return;
    }
    try {
      const { data } = await createAd({
        variables: {
          input: {
            title: currentTitle,
          }
        }
      });
      navigate(`/ad/${data.createAd.id}/edit`);
    } catch (error) {
      console.error('Error creating ad:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Create New Ad</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <TranslatedValue
              translations={title}
              renderAs="input"
              label="Ad Title"
              required
              autoFocus
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-hidden focus:ring-2 focus:ring-blue-500"
              onEditTranslation={(updates) => setTitle(mergeTranslations(titleRef.current, updates))}
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
